import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { UI_FEATURES } from 'src/app/core/enums/ui.enum';
import { UiStoreService } from 'src/app/core/services/ui-store.service';

@Component({
  selector: 'app-left-bar',
  templateUrl: './left-bar.component.html',
  styleUrl: './left-bar.component.scss'
})
export class LeftBarComponent {
  UI_FEATURES = UI_FEATURES
  @ViewChild('leftMenuRef') public leftMenuRef: MatSidenav | undefined;
  
  constructor(public uiStore: UiStoreService) { }

  ngAfterViewInit(): void {
    this.uiStore.leftMenuRef = this.leftMenuRef;
  }

}
